const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    },
    fusdt: {
        id: 'fusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'fUSDT',
        decimals: 1e6,
        address: '0x049d68029688eabf473097a2fc38ef61633a3c7a',
    },
    twocrv: {
        id: 'twocrv',
        type: REFERENCE_ASSETS.USD,
        symbol: '2Crv',
        decimals: 1e18,
        address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        isLpToken: true,
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x321162Cd933E2Be498Cd2267a90534A804051b11',
    },
    renbtc: {
        id: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
    },
};
